(function () {
  if (window.careersInitialized) return;
  window.careersInitialized = true;

  function getSelects() {
    return document.querySelectorAll('[data-careers-position-select]');
  }

  function addOption(select, title) {
    var exists = Array.prototype.some.call(select.options, function (option) {
      return option.value === title;
    });
    if (exists) return;

    var option = document.createElement('option');
    option.value = title;
    option.textContent = title;
    // Listed positions go above the extra options (e.g. "General Application").
    var firstExtra = select.querySelector('option:not([disabled]):not([data-careers-listed])');
    option.setAttribute('data-careers-listed', '');
    select.insertBefore(option, firstExtra);
  }

  function syncPositions() {
    var titles = Array.prototype.map.call(document.querySelectorAll('[data-careers-position]'), function (el) {
      return el.getAttribute('data-careers-position').trim();
    });

    getSelects().forEach(function (select) {
      select.querySelectorAll('[data-careers-listed]').forEach(function (option) {
        if (titles.indexOf(option.value) === -1 && !option.selected) option.remove();
      });
      titles.forEach(function (title) {
        if (title) addOption(select, title);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-careers-apply]');
    if (!trigger) return;

    var title = trigger.getAttribute('data-careers-apply');
    getSelects().forEach(function (select) {
      addOption(select, title);
      select.value = title;
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPositions);
  } else {
    syncPositions();
  }

  // Keep the dropdown in sync while editing in the theme editor.
  ['shopify:section:load', 'shopify:block:select', 'shopify:section:reorder'].forEach(function (name) {
    document.addEventListener(name, syncPositions);
  });

  // Expand a position when its block is selected in the theme editor.
  document.addEventListener('shopify:block:select', function (event) {
    if (event.target.matches && event.target.matches('details.careers-position')) {
      event.target.open = true;
    }
  });
})();
